// small UI component used in create manual JPAs index page (overview page of  manuallycreated JPA)

// Imported in:
// 1) './JPAItem.js'

// **Props**
// Close: a function that sets the relevant state in parent to false to close the modal
// LangData: Language labels (ids and label texts of the selected system language)
// Confirm: a function that is called when delete is confirmed by the user
// JPAItem: the related Job / Project / Activity selected to delete

import React from "react";

const DeleteJPAmodal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div className="modal-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="modal-body">
        <section className="modal-head">
          <h1>{props.JPAItem.title}</h1>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </section>
        <section className="modal-main">
          <h1>{translateText("delete_modal_text")}</h1>
          <section className="modal-actions">
            <span
              className="modal-action cancel-btn"
              onClick={() => props.Close()}
            >
              {translateText("cancel")}
            </span>
            <span
              className="modal-action delete-btn"
              onClick={() => props.Confirm()}
            >
              {translateText("delete")}
            </span>
          </section>
        </section>
      </div>
    </div>
  );
};

export default DeleteJPAmodal;
